import React from 'react';
import Box from '@mui/material/Box';

// A small circular color swatch, commonly used in DataGrid renderCell.
// Props:
// - color: string (hex/rgb) background color of the circle; if falsy, renders null
// - size: number diameter in px (default 20)
// - withShadow: boolean apply subtle shadow (default true)
// - centered: boolean center the circle in a full-size container (default true)
// - sx: optional MUI sx overrides for the circle
const ColorCircleUi = ({ color, size = 20, withShadow = true, centered = true, sx = {}, ...props }) => {
  if (!color) return null;

  const circle = (
    <Box
      sx={{
        borderRadius: '50%',
        width: size,
        height: size,
        backgroundColor: color,
        boxShadow: withShadow ? '0px 1px 8px rgba(0,0,0,0.54)' : 'none',
        ...sx,
      }}
      {...props}
    />
  );

  if (!centered) return circle;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
      {circle}
    </Box>
  );
};

export default ColorCircleUi;
